import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import arrowBackBlack from 'assets/img/arrowBackBlack.svg';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 140,
  backgroundColor: colors.greyLight,
  color: colors.darkBrown,
});

export const Header = styled('header')({
  position: 'relative',
  padding: 'calc(40px + env(safe-area-inset-top)) 20px 20px',
  textAlign: 'center',
});

export const BackButton = styled('button')({
  position: 'absolute',
  top: 'calc(36px + env(safe-area-inset-top))',
  left: 20,
  width: 32,
  height: 32,
  border: 'none',
  backgroundColor: 'transparent',
  backgroundImage: `url(${arrowBackBlack})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  cursor: 'pointer',
});

export const Title = styled('h1')({
  margin: '4px 0 0',
  fontFamily: fonts.title,
  fontSize: 30,
  lineHeight: 1.1,
  color: colors.black,
});

export const Slide = styled('section')({
  margin: '0 20px 16px',
  backgroundColor: colors.darkBrown,
  color: colors.white,
});

export const SlideImage = styled('img')({
  display: 'block',
  width: '100%',
  height: 150,
  objectFit: 'cover',
});

export const SlideText = styled('div')({
  padding: '14px 16px 16px',
  fontSize: 14,
  lineHeight: '21px',
  '& br': {display: 'none'},
});

export const SlideSubtitle = styled('h2')({
  margin: '0 0 6px',
  fontFamily: fonts.title,
  fontSize: 18,
  color: colors.beige,
});

export const SubOffer = styled('section')({
  margin: '20px 20px 0',
});

export const SubOfferHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  marginBottom: 12,
});

export const SubOfferTitle = styled('h2')({
  margin: 0,
  fontFamily: fonts.title,
  fontSize: 22,
  color: colors.black,
  '& span': {
    fontFamily: fonts.default,
    fontSize: 14,
    color: colors.caramel,
  },
});

export const Badge = styled('img')({
  width: 48,
  height: 48,
  objectFit: 'contain',
});

export const Grid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: 12,
});

export const Product = styled('article')({
  padding: '14px 10px 12px',
  backgroundColor: colors.white,
  textAlign: 'center',
});

export const ProductImage = styled('img')({
  display: 'block',
  width: '100%',
  height: 110,
  objectFit: 'contain',
  marginBottom: 8,
});

export const ProductTitle = styled('h3')({
  margin: 0,
  fontFamily: fonts.title,
  fontSize: 15,
  lineHeight: '19px',
  color: colors.black,
});

export const ProductSubtitle = styled('p')({
  margin: '4px 0 0',
  fontSize: 12,
  lineHeight: '16px',
  color: colors.grey,
});

export const Notion = styled('p')({
  margin: '4px 0 0',
  fontSize: 11,
  lineHeight: '15px',
  fontWeight: 'bold',
  color: colors.caramel,
});

export const Order = styled('p')({
  margin: '28px 20px 0',
  textAlign: 'center',
  fontWeight: 'bold',
});

export const Mentions = styled('div')({
  margin: '20px 20px 0',
  fontSize: 11,
  lineHeight: '16px',
  color: colors.grey,
});
